// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"f01d5dc75cc4d833b99b","873":"c75c3f8eb4c731bd6861"}[chunkId] + ".js";
};